import { language } from "@chef/constants";

export const intl = (
  {
    no: {
      OPT_OUT_OF_RAATASS: "Klikk her for å melde deg ut av Råtass",
      RAATASS_DESCRIPTION:
        "Du bidrar til idretten gjennom vårt samarbeid med Råtass. Dermed går kr 10,- av hver bestilling til ditt idrettslag.",
    },
    se: {
      OPT_IN_TO_RAATASS: "NOT_ELIGABLE",
      OPT_OUT_OF_RAATASS: "NOT_ELIGABLE",
      RAATASS_DESCRIPTION: "NOT_ELIGABLE",
    },
    dk: {
      OPT_IN_TO_RAATASS: "NOT_ELIGABLE",
      OPT_OUT_OF_RAATASS: "NOT_ELIGABLE",
      RAATASS_DESCRIPTION: "NOT_ELIGABLE",
    },
  } as const
)[language];
